import React from "react";
import { Box,Card, Paragraph,Image,ResponsiveContext,Grid,Tab,Tabs,Text, Heading, CardBody,CardFooter, CardHeader, Button,Accordion,AccordionPanel} from 'grommet'
import {Down,FormAdd} from 'grommet-icons'
import {WhyToInfoCard} from './WhyToInfoCard'


function genBetween(min, max) {  
    return Math.floor(
      Math.random() * (max - min + 1) + min
    )
  }

  function getCardSize(currentSize){
    if(currentSize=='small') return 'xsmall'
    else if(currentSize=='medium') return 'small'
    else return 'medium'
  }



  function mobileCheck() {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }


function ServicesGrid(props){
    const size = React.useContext(ResponsiveContext);
    if(!mobileCheck())
    return(
        <Grid
            areas={[
              { name: 'oneone', start: [0, 0], end: [0, 0] },
              { name: 'onetwo', start: [1, 0], end: [1, 0] },
              { name: 'onethree', start: [2, 0], end: [2, 0] },
              { name: 'onefour', start: [3, 0], end: [3, 0] },
              { name: 'onefive', start: [4, 0], end: [4, 0] },
              { name: 'twoone', start: [0, 1], end: [0, 1] },
              { name: 'twotwo', start: [1, 1], end: [1, 1] },
              { name: 'twothree', start: [2, 1], end: [2, 1] },
              { name: 'twofour', start: [3, 1], end: [3, 1] },
              { name: 'twofive', start: [4, 1], end: [4, 1] },
              { name: 'threeone', start: [0, 2], end: [0, 2] },
              { name: 'threetwo', start: [1, 2], end: [1, 2] },
              { name: 'threethree', start: [2, 2], end: [2, 2] },
              { name: 'threefour', start: [3, 2], end: [3, 2] },
              { name: 'threefive', start: [4, 2], end: [4, 2] },

            ]}
            columns={['1/5', '1/5', '1/5','1/5','1/5']}
            rows={['1/3','1/3','1/3']}
            gap="medium"
            pad={{left:'large',right:'large',top:'large',bottom:'large'}}
            alignSelf='center'
            align='center'
            alignContent="center"
          >
        <Card align='center' alignSelf='center'  gridArea='oneone' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service1.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Accommodation</Paragraph>
            </CardHeader>
        </Card> 
        <Card align='center' alignSelf='center'  gridArea='onetwo' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service2.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Logistics</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='onethree' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service3.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Bank/Payment</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='onefour' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service4.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Corona test/ Arrival/ Quarantine</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='onefive' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service5.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Feedback from supervisors</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='twoone' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service6.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Guest/Scholarship/<br/>Contract issues</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='twotwo' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service7.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>ARD ZDF costs (GEZ)</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='twothree' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service8.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Bicyle/Transport</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='twofour' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service9.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Passport/Visa issues</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='twofive' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service10.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Quarantine support/ Discussion</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='threeone' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service11.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Medical insurance</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='threetwo' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service13.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Social engagement</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='threethree' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service14.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Questions and consultations</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='threefour' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service15.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Video meetings to support and get feedback</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='threefive' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service17.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Introduction to Germany and culture</Paragraph>
            </CardHeader>
        </Card>
             </Grid>
    );
    else
    return(
        <Box gap='large' direction="column">
        <Card align='center' alignSelf='center'  gridArea='oneone' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service1.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Accommodation</Paragraph>
            </CardHeader>
        </Card> 
        <Card align='center' alignSelf='center'  gridArea='onetwo' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service2.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Logistics</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='onethree' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service3.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Bank/Payment</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='onefour' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service4.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Corona test/ Arrival/ Quarantine</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='onefive' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service5.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Feedback from supervisors</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='twoone' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service6.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Guest/Scholarship/<br/>Contract issues</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='twotwo' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service7.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>ARD ZDF costs (GEZ)</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='twothree' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service8.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Bicyle/Transport</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='twofour' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service9.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Passport/Visa issues</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='twofive' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service10.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Quarantine support/ Discussion</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='threeone' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service11.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Medical insurance</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='threetwo' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service12.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>...</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='threethree' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service13.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Social engagement</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='threefour' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service14.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Questions and consultations</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='threefive' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service15.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Video meetings to support and get feedback</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='fourone' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service17.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Introduction to Germany and culture</Paragraph>
            </CardHeader>
        </Card>
        <Card align='center' alignSelf='center'  gridArea='fourtwo' width='small' height='small'>
            <CardBody >
            <Image fill={true} fit='cover' src={require("../assets/service16.png")} />
            </CardBody>
            <CardHeader>
                <Paragraph style={{fontWeight:'bold', textAlign:'center'}} color='brand'>Communication</Paragraph>
            </CardHeader>
        </Card>
        <br/>
        </Box>
    );
}

export {ServicesGrid}